import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config';
import '../assets/css/style.css';

function Login({ setAuth }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_URL}/login`, { username, password });
      localStorage.setItem('user_role', res.data.role);
      localStorage.setItem('user_id', res.data.user_id);
      localStorage.setItem('username', res.data.username);
      localStorage.setItem('full_name', res.data.full_name || res.data.username);
      localStorage.setItem('user_divisions', JSON.stringify(res.data.divisions || []));
      localStorage.setItem('user_countries', JSON.stringify(res.data.countries || []));
      localStorage.setItem('user_permissions', JSON.stringify(res.data.permissions || []));
      
      if (res.data.must_change_password) {
        localStorage.setItem('must_change_password', 'true');
        setAuth(res.data.token);
        navigate('/change-password');
      } else {
        localStorage.removeItem('must_change_password');
        setAuth(res.data.token);
        navigate('/');
      }
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="login-wrapper">
      {/* Left Side: Brand & Company Information */}
      <div className="login-banner">
        <div className="banner-content">
          <div className="brand">
            <h1 className="logo-text">ACTS</h1>
            <h2 className="company-name">Advanced Construction Technology Services</h2>
          </div>
          <div className="hero-text">
            <h3>A Legacy of Excellence</h3>
            <p>Since 1996, the regional leader in construction consultancy, materials testing, and geo-engineering.</p>
          </div>
          <div className="pillars">
            <div className="pillar"><i className="fas fa-check-circle"></i> Quality &amp; Safety</div>
            <div className="pillar"><i className="fas fa-flask"></i> Testing &amp; Inspection</div>
            <div className="pillar"><i className="fas fa-hard-hat"></i> Engineering Services</div>
          </div>
        </div>
        <div className="banner-overlay"></div>
      </div>

      {/* Right Side: Login Form */}
      <div className="login-form-container">
        <div className="form-wrapper">
          <div className="mobile-logo">ACTS</div>
          <h2>Welcome Back</h2>
          <p className="subtitle">Sign in to access your ACTS applications.</p>

          <form id="actsLoginForm" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="username">Corporate Email or Username</label>
              <div className="input-wrapper">
                <i className="fas fa-envelope input-icon"></i>
                <input 
                  type="text" 
                  id="username" 
                  name="username" 
                  placeholder="e.g. j.doe@acts-int.com" 
                  autoComplete="username"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <i className="fas fa-lock input-icon"></i>
                <input 
                  type={showPassword ? "text" : "password"} 
                  id="password" 
                  name="password" 
                  placeholder="Enter your password" 
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button 
                  type="button" 
                  className="toggle-password" 
                  id="togglePasswordBtn" 
                  aria-label="Toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} id="togglePasswordIcon"></i>
                </button>
              </div>
              {error && <span className="error-msg" id="passwordError">{error}</span>}
            </div>

            <div className="form-actions">
              <label className="checkbox-container">
                <input type="checkbox" id="rememberMe" />
                <span className="checkmark"></span>
                Remember me
              </label>
             
            </div>

            <button type="submit" className="btn btn-primary btn-block" id="loginBtn" style={{ padding: '1rem', fontSize: '1.05rem' }}>
              <span>Sign In</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </form>

          <div className="system-notice">
            <p><i className="fas fa-shield-alt"></i> Secure access for authorized ACTS personnel only. <br />Need help? <a href="#">Contact IT Support</a></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
